var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1048_18865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.344 8.18429C16.344 7.64047 16.3 7.09371 16.2059 6.55872H8.66003V9.63937H12.9812C12.8019 10.6329 12.2257 11.5119 11.3821 12.0704V14.0693H13.9601C15.4739 12.6759 16.344 10.6182 16.344 8.18429Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65999 16.0005C10.8176 16.0005 12.6372 15.2921 13.9629 14.0692L11.385 12.0703C10.6677 12.5583 9.74174 12.8346 8.66293 12.8346C6.57584 12.8346 4.80623 11.4266 4.17128 9.53351H1.51099V11.5941C2.86906 14.2956 5.63518 16.0005 8.65999 16.0005Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16839 9.53349C3.83328 8.53992 3.83328 7.46405 4.16839 6.47048V4.40985H1.51104C0.376367 6.67037 0.376367 9.3336 1.51104 11.5941L4.16839 9.53349Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65999 3.16644C9.80053 3.1488 10.9029 3.57798 11.7289 4.36578L14.0129 2.08174C12.5667 0.72367 10.6471 -0.0229773 8.65999 0.000539111C5.63518 0.000539111 2.86906 1.70548 1.51099 4.40987L4.16834 6.4705C4.80035 4.57449 6.5729 3.16644 8.65999 3.16644Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1048_18865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.39a2e20737e95883ad75910ebcdfa38f.svg";
export { ForwardRef as ReactComponent };